import React from 'react';
import PropTypes from 'prop-types';
import TextArea from '../forms/TextArea';
import RichText from '../forms/RichText';
import TextInput from '../forms/TextInput';
import SelectMenu from '../forms/SelectMenu';
import { humanize } from '../helpers/humanize';
import Dialog from './Dialog';
import ImagePicker from '../pickers/ImagePicker/ImagePicker';

import Tabs from '../raketa-ui/components/Tabs';

const renderField = (field, value, onChange, opts) => {
  switch (opts.type) {
    case 'text': {
      return (<TextInput
        key={`dialog-${field}`}
        label={opts.label}
        value={value}
        onChange={newValue => onChange(field, newValue)}
      />);
    }

    case 'textarea': {
      return (
        <TextArea
          key={`dialog-${field}`}
          label={opts.label}
          value={value}
          onChange={newValue => onChange(field, newValue)}
        />);
    }

    case 'rich': {
      return (
        <RichText
          key={`dialog-${field}`}
          label={opts.label}
          value={value}
          onChange={newValue => onChange(field, newValue)}
        />);
    }

    case 'select': {
      return (
        <SelectMenu
          key={`dialog-${field}`}
          label={opts.label}
          options={opts.options}
          value={value}
          onChange={newValue => onChange(field, newValue)}
        />);
    }

    case 'image': {
      return (
        <ImagePicker
          key={`dialog-${field}`}
          label={opts.label}
          value={value}
          onChange={newValue => onChange(field, newValue)}
        />
      );
    }

    // case 'component': {
    //   const componentName = opts.component;
    //
    //   return React.createElement(window[componentName], {
    //     key: `dialog-${field}`,
    //     value,
    //     onChange: newValue => onChange(field, newValue),
    //   });
    // }

    default: {
      return (<TextInput
        key={`dialog-${field}`}
        label={field}
        value={value}
        onChange={newValue => onChange(field, newValue)}
      />);
    }
  }
};

const SettingsDialog = ({
  open,
  widget,
  settings,
  onChangeField,
  onClose,
  onPrimary,
  headerToolbar,
  dialogSize,
}) => {
  let fields;

  if (typeof widget.adminFields === 'object') {
    fields = Object.keys(widget.adminFields).map(field =>
      renderField(
        field,
        settings[field],
        onChangeField,
        Object.assign({ label: humanize(field) }, widget.adminFields[field])),
      );
  }

  if (typeof widget.adminFields === 'function') {
    const items = settings.list ? settings.list : [];

    fields = widget.adminFields(items, onChangeField, settings);
  }

  return (
    <Dialog
      open={open}
      title={widget.title}
      primaryLabel="Save"
      width="700px"
      onPrimary={onPrimary}
      onClose={onClose}
      dialogSize={widget.dialogSize}
    >
      <Tabs>
        <div title="Content">{fields}</div>
        <div title="Settings">{headerToolbar()}</div>
      </Tabs>
    </Dialog>
  );
};

SettingsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  widget: PropTypes.func.isRequired,
  settings: PropTypes.object.isRequired,
  onChangeField: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onPrimary: PropTypes.func.isRequired,
  headerToolbar: PropTypes.func,
  dialogSize: PropTypes.string,
};


export default SettingsDialog;
